<template>
  <div class="top_bar">
    <router-link to
      ><el-button class="back" @click="$router.back(-1)">{{
        $t("List.button1")
      }}</el-button></router-link
    >
    <router-link :to="'/'"
      ><el-button class="back">{{ $t("List.button2") }}</el-button></router-link
    >
  </div>
  <div class="zhanwei2"></div>
  <el-tabs :tab-position="tabPosition">
    <el-tab-pane :label="$t('List.creationList')">
      <div class="game" v-for="(item, index) in gameList" :key="index">
        <div class="game_left">
          <el-image :src="item.gameCover" fit="fill"></el-image>
        </div>
        <div class="game_center">
          <p>{{ item.gameTitle }}</p>
          <p>建立于{{ item.createTime }}</p>
          <p>导览编号{{ item.id }}</p>
          <p>{{ item.gameLanguage }} 不限地区─ 任何地点</p>
          <p>{{ item.gameDesc.trim() }}</p>
        </div>
        <div class="game_right">
          <p v-if="item.updateTime != null">
            {{ $t("List.tip") }}{{ item.updateTime }}
          </p>
          <h4 class="game_right_edit" @click="editGame(item.id)">
            {{ $t("List.button3") }}
          </h4>
          <h4 class="game_right_delete" @click="deleteGame(item.id)">
            {{ $t("List.button4") }}
          </h4>
        </div>
      </div>
      <div class="zhanwei3"></div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="gamesTotal"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('List.trashCan')">
      <div class="game" v-for="(item, index) in junkGameList" :key="index">
        <div class="game_left">
          <el-image :src="item.gameCover" fit="fill"></el-image>
        </div>
        <div class="game_center">
          <p>{{ item.gameTitle }}</p>
          <p>建立于{{ item.createTime }}</p>
          <p>导览编号{{ item.id }}</p>
          <p>{{ item.gameLanguage }} 不限地区─ 任何地点</p>
          <p>{{ item.gameDesc.trim() }}</p>
        </div>
        <div class="game_right">
          <p v-if="item.deleteTime != null">
            剩余保留天数：{{ this.getDaysDifference(item.deleteTime) }}天
          </p>
          <h4 class="game_right_edit" @click="restore(item.id)">还原</h4>
          <h4 class="game_right_delete" @click="completeDelete(item.id)">
            {{ $t("List.button4") }}
          </h4>
        </div>
      </div>
      <div class="zhanwei3"></div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="junkGameListTotal"
          @current-change="handleCurrentChange2"
        /></div
    ></el-tab-pane>
  </el-tabs>
</template>

<script lang="ts">
import { defineComponent, markRaw } from "vue";
import { Game } from "@/views/view";
import { ElMessage, ElMessageBox } from "element-plus";
import { Delete } from "@element-plus/icons-vue";

export default defineComponent({
  name: "gameList",
  data(): any {
    return {
      currentPage: 1,
      currentPage2: 1,
      tabPosition: "left",
      junkGameListTotal: 1,
      junkGameList: [],
    };
  },
  computed: {
    gameList(): Array<Game> {
      return this.$store.state.game.games;
    },
    gamesTotal() {
      return this.$store.state.game.total;
    },
  },
  watch: {},
  created() {
    this.fetchGameList(this.currentPage);
    this.fetchJunkGameList(this.currentPage2);
  },
  methods: {
    handleCurrentChange(val: number) {
      this.fetchGameList(val);
    },
    handleCurrentChange2(val: number) {
      this.fetchJunkGameList(val);
    },

    fetchGameList(pageNum: number) {
      const userId = this.$store.state.user.Id;
      const pageSize = 10;
      const status = 0;

      this.$store
        .dispatch("game/getGameList", { pageNum, pageSize, userId, status })
        .then((res: any) => {})
        .catch((err: any) => {
          console.error(err);
        });
    },
    fetchJunkGameList(pageNum: number) {
      const userId = this.$store.state.user.Id;
      const pageSize = 10;
      const status = 0;

      this.$store
        .dispatch("game/getJunkGameList", { pageNum, pageSize, userId, status })
        .then((res: any) => {
          this.junkGameListTotal = res.total;
          this.junkGameList = res.records;
          console.log(this.junkGameList);
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
    getDaysDifference(endDate: any) {
      // 将日期字符串或日期对象转为 Date 对象
      const start: any = new Date();
      const end: any = new Date(endDate);

      // 计算两个日期之间的差异，单位为毫秒
      const timeDiff = end - start;

      // 将毫秒转换为天数 (1天 = 24小时 * 60分钟 * 60秒 * 1000毫秒)
      const diffInDays = timeDiff / (1000 * 60 * 60 * 24);

      return Math.round(diffInDays); // 返回相差的天数，四舍五入
    },
    editGame(id: string) {
      this.$router.push("/edit/" + id + "/cover");
    },
    restore(id: string) {
      this.$store
        .dispatch("game/restoreGame", { id: id })
        .then((res: any) => {
          this.fetchGameList(this.currentPage);
          this.fetchJunkGameList(this.currentPage2);
        })
        .catch(() => {});
    },
    deleteGame(id: string) {
      ElMessageBox.confirm(this.$t("List.deleteInfo"), "Warning", {
        type: "warning",
        icon: markRaw(Delete),
        confirmButtonText: this.$t("List.confirm"),
        cancelButtonText: this.$t("List.channel"),
        draggable: true,
        overflow: true,
      })
        .then(() => {
          this.$store
            .dispatch("game/delGame", { ids: [id] })
            .then((res: any) => {
              if (res == 1) {
                this.fetchGameList(this.currentPage);
                this.fetchJunkGameList(this.currentPage2);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },

    completeDelete(id: string) {
      ElMessageBox.confirm("是否彻底删除数据，此举不可恢复", "Warning", {
        type: "warning",
        icon: markRaw(Delete),
        confirmButtonText: this.$t("List.confirm"),
        cancelButtonText: this.$t("List.channel"),
        draggable: true,
        overflow: true,
      })
        .then(() => {
          this.$store
            .dispatch("game/completeGame", { id: id })
            .then((res: any) => {
              if (res == 1) {
                this.fetchJunkGameList(this.currentPage2);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
@import "@/static/less/list";
</style>
